import React, { useState } from "react";
import QRScanner from "./QRScanner";
import { Form, Select, Button, message } from "antd";
import { _postnew } from "../../../Utils/Helper";

const AdminAttendanceScanner: React.FC = () => {
  const [mode, setMode] = useState<"check-in" | "check-out" | null>(null);
  const [isScanning, setIsScanning] = useState(false);

  const handleScanSuccess = (
    decodedText: string,
    location?: GeolocationCoordinates
  ) => {
    const currentTime = new Date().toISOString();

    // Parse the decoded data
    const userData = JSON.parse(decodedText); // Assuming the QR code contains JSON with user details

    // Validate the data
    if (!userData.role || !userData.name) {
      message.error("Invalid QR code data");
      return;
    }

    // Send the data to the database
    const attendanceData = {
      name: userData.name,
      role: userData.role,
      department: userData.department,
      time: currentTime,
      mode,
      location: location ? `${location.latitude}, ${location.longitude}` : null
    };

    console.log("Attendance Data to Send:", attendanceData);

    // Example API call
    _postnew(
      "attendance",
      attendanceData,
      (response) => {
        console.log("", response);
        if (response && response.id) {
          message.success(
            `${userData.name} ${
              mode === "check-in" ? "checked in" : "checked out"
            } successfully.`
          );
        }
      },
      (error) => {
        console.error("Error generating QR code:", error);
        message.error("Failed to generate QR code");
      },
      true
    );
  };

  return (
    <div className="w-full max-w-lg mx-auto p-4">
      <h2 className="text-xl font-bold mb-4">Admin Attendance Scanner</h2>
      <Form layout="vertical" className="mb-4">
        <Form.Item label="Select Mode">
          <Select
            placeholder="Check-in or Check-out"
            onChange={(value) => setMode(value)}
            value={mode}
          >
            <Select.Option value="check-in">Check-in</Select.Option>
            <Select.Option value="check-out">Check-out</Select.Option>
          </Select>
        </Form.Item>
        <Button
          type="primary"
          disabled={!mode}
          onClick={() => setIsScanning(true)}
          className="w-full"
        >
          Start Scanning
        </Button>
      </Form>
      {isScanning && (
        <QRScanner onScanSuccess={handleScanSuccess} requireLocation={true} />
      )}
    </div>
  );
};

export default AdminAttendanceScanner;
